import { render, staticRenderFns } from "./firstGoodsHistory.vue?vue&type=template&id=b7f269bc&scoped=true"
import script from "./firstGoodsHistory.vue?vue&type=script&lang=js"
export * from "./firstGoodsHistory.vue?vue&type=script&lang=js"
import style0 from "./firstGoodsHistory.vue?vue&type=style&index=0&id=b7f269bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f269bc",
  null
  
)

export default component.exports